export * from './processClassDef.js';
export * from './processClassInstance.js';
export * from './processClassInstFunction.js';
export * from './processDefaultExport.js';
export * from './processFunction.js';
export * from './processFunctionWithCasesArray.js';
export * from './processModule.js';
export * from './processObject.js';
export * from './processOnlyField.js';